import LayoutComponent from "../components/LayoutComponent";
import TableComponent from "../components/TableComponent";
import { useHistory } from "react-router-dom";
import {useEffect, useState} from 'react';
import {useApi} from "../provider/ApiProvider";
import {Button, Popconfirm, Switch} from 'antd';
import {DeleteOutlined, EditFilled, PlusOutlined, RightOutlined} from "@ant-design/icons";
import moment from 'moment';


export default function ActivityPage(){

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: text => <a>{text}</a>,
        },
        {
            title: 'Resim',
            render: record => <img src={record.image} height={40}/>
        },
        {
            title: 'Başlık',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Firma/Şube',
            render: (record) => record?.Company?.name
        },
        {
            title: 'Müşteri(Kuruluş)',
            render: (record) => record?.Customer?.name
        },
        {
            title: 'Başlangıç',
            render: (record) => moment(record?.beginDate).format('DD.MM.YYYY')
        },
        {
            title: 'Bitiş',
            render: (record) => moment(record?.endDate).format('DD.MM.YYYY')

        },
        {
            title: 'Durum',
            render: (record) => (
                <Switch defaultChecked={record.isActive} onChange={(checked) => {
                    updateStatus(record.id, checked);
                }}/>
            )
        },
        {
            title: 'İşlemler',
            render: (record) => (
                <div>
                    <Popconfirm
                        title="Silmek istediğinize emin misiniz?"
                        onConfirm={() => {deleteRow(record.id)}}
                        onCancel={() => {
                            return;
                        }}
                        okText="Evet"
                        cancelText="Hayır"
                    >
                        <Button danger><DeleteOutlined/></Button>
                    </Popconfirm>
                    <Button style={{marginLeft: '4%'}} onClick={() => clickRow(record)}>
                        <EditFilled />
                    </Button>

                </div>
            )
        }

    ];

    let history = useHistory();
    const {api} = useApi();
    const [news, setNews] = useState({totalCount: 0, items: []})

    useEffect(() => {
        load({skip: 0, max: 10})
    },[])

    async function load(params){
        await api.get('/activityRouter/activity/all', params).then(resp => {
            setNews({totalCount: resp.totalCount, items: resp.data});
        })
    }

    function clickRow(item){
        history.push("/activity/add/" + item.id);
    }

    async function updateStatus(id, value){
        await api.put('/new/update/' + id, {isActive: value}).then(resp => {
            load();
        })
    }

    async function deleteRow(id){
        await api.delete('/activityRouter/activity/delete/' + id).then(resp => {
            load();
        })
    }

    return (
        <LayoutComponent title={"Sliderler"} links={
            [
                {
                    title: 'Sliderler',
                    url: '/'
                },

            ]}
         newButton={<>
             <Button icon={<PlusOutlined />} onClick={() => history.push("/activity/add")} type="primary">Ekle</Button>
         </>}>
            <TableComponent
                columns={columns}
                data={news}

            />
        </LayoutComponent>
    )
}
